import { render, staticRenderFns } from "./TestData.vue?vue&type=template&id=ee40b1fe&scoped=true&"
import script from "./TestData.vue?vue&type=script&lang=js&"
export * from "./TestData.vue?vue&type=script&lang=js&"
import style0 from "./TestData.vue?vue&type=style&index=0&id=ee40b1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee40b1fe",
  null
  
)

export default component.exports